import { discardDraftRequestedAction } from '../../../../drafts/actions/DiscardDraftAction';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { Messages } from '../../../../codegen/Localize';
import { IEntityAction, EntityActionNames } from './IEntityAction';


export const DiscardDraftEntityAction: IEntityAction<IContentInfo<'workbook'>, {}> = {
    name: EntityActionNames.DiscardDraft,
    translateName: Messages.discardChanges,
    isVisible: (targetItems: IContentInfo[]) => !!(targetItems[0].draftLuid),
    isClickable: (availableActions: any, targetItems: IContentInfo[]) => !!(targetItems[0].draftLuid),
    createReduxAction: (targetItems: IContentInfo[]) => {
        return discardDraftRequestedAction(
            targetItems[0].draftLuid,
            targetItems[0].contentType,
            targetItems[0].luid,
            targetItems[0].name
        );
    }
};
